import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import Button from '@mui/material/Button';
import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {TablePaginationWithPageSelector} from '../../TablePaginationWithPageSelector.jsx';

/**
 * This component display a simple popup with the list of SAP PR Number generated
 * @param {MassCreationInvalidPrsPopup.propTypes} props
 * @return {JSX.Element}
 */
export function MassCreationInvalidPrsPopup(props) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [pageNum, setPageNum] = useState([]);
    const pageSize = rowsPerPage === -1 ? props.invalidPrs.length : (props.invalidPrs.length) / rowsPerPage;
    const handlePageSelection = (newValue) => {
        setPage(newValue);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    useEffect(() => {
        const temp = [];
        if (rowsPerPage === -1) {
            temp.push(
                {
                    label: `1-${props.invalidPrs.length}`,
                    value: 1,
                },
            );
        } else {
            for (let i = 0; i < pageSize; i++) {
                temp.push({
                    label: `${(i * rowsPerPage) + 1}-${(i + 1) * rowsPerPage < props.invalidPrs.length ? (i + 1) * rowsPerPage : props.invalidPrs.length}`,
                    value: i + 1,
                });
            }
        }
        return setPageNum(temp);
    }, [pageSize]);

    const paginatedPRs = props.invalidPrs.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <Dialog
            onClose={props.onClose}
            open={props.open}
            aria-labelledby="warning-popup"
        >
            <div style={{display: 'flex'}}>
                <div style={{
                    backgroundColor: '#F19002',
                    width: '20%',
                    height: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: '50px',
                    justifyContent: 'center',
                }}>
                    <i className="material-icons" style={{color: 'white'}}>{'pending_actions'}</i>
                </div>
                <div>
                    <DialogTitle id="popup-title">Mass PR creation</DialogTitle>
                    <DialogContent>
                        <DialogContentText>Validation failed for the following PSL Material Id's:</DialogContentText>
                        <ul>
                            {paginatedPRs.map((item) => (
                                <li key={`${item.id}-${item.materialPSLId}`}>
                                    <DialogContentText id="list-of-prs">
                                        {`EPR ID: ${item.id} -> PSL Material ID: ${item.materialPSLId}`}
                                    </DialogContentText>
                                </li>
                            ))}
                        </ul>
                        <div style={{marginBottom: '5rem'}}>
                            <TablePaginationWithPageSelector
                                page={page}
                                pageNum={pageNum}
                                rowsPerPage={rowsPerPage}
                                handleChangeRowsPerPage={handleChangeRowsPerPage}
                                handleChangePage={handleChangePage}
                                handlePageSelection={handlePageSelection}
                                count={props.invalidPrs.length}
                                rowsPerPageOptions={[2, 5, 10, 20, 50, 100, 200]}
                                textColor="rgba(0, 0, 0, 0.6)"
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={props.onClose}>
                            Ok
                        </Button>
                    </DialogActions>
                </div>
            </div>
        </Dialog>
    );
}

MassCreationInvalidPrsPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    invalidPrs: PropTypes.arrayOf(PropTypes.object).isRequired,
};
